<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M15.888 8.777l2.765-2.768a5.193 5.193 0 017.158.18 5.208 5.208 0 01.182 7.17l-3.959 3.949-.003.002a5.168 5.168 0 01-5.643 1.127 5.167 5.167 0 01-1.679-1.127 1 1 0 00-1.418 1.411 7.167 7.167 0 0010.157.002l.001-.002 3.974-3.964a7.207 7.207 0 00-.197-9.98 7.193 7.193 0 00-9.97-.199l-2.783 2.785a1 1 0 001.415 1.414zm-4.24 4.785a5.163 5.163 0 015.643 1.126 1 1 0 001.418-1.41 7.167 7.167 0 00-10.156-.002l-3.975 3.966a7.208 7.208 0 00.197 9.98 7.193 7.193 0 009.97.199l2.783-2.786a1 1 0 10-1.415-1.413l-2.766 2.768a5.192 5.192 0 01-7.158-.181 5.208 5.208 0 01-.181-7.169l3.959-3.95.002-.002a5.168 5.168 0 011.68-1.126z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'webSystemLinkOutline'
}
</script>
